import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { OpenFileHelperService } from '../../service/open-file-helper.service';

@Component({
    selector: 'app-photo-preview',
    templateUrl: './photo-preview.component.html',
    styleUrls: ['./photo-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PhotoPreviewComponent {
  constructor(private readonly _openFileHelperService: OpenFileHelperService) {}

  @Input() src: string | Blob = '';
  @Input() fileName: string = '';
  @Input() isOpen: boolean = false;
  @Output() close = new EventEmitter<boolean>();

  hide() {
    this.close.emit(this.isOpen);
  }

  openImageInNewTab() {
    if (typeof this.src === 'string') {
      if (this.src.startsWith('data:')) {
        this._openFileHelperService.openBlobInNewTab(this.dataURLtoBlob(this.src));
      } else {
        this._openFileHelperService.openUrlInNewTab(this.src);
      }
      return;
    }

    this._openFileHelperService.openBlobInNewTab(this.src);
  }

  private dataURLtoBlob(dataURL: string) {
    const [metadata, base64] = dataURL.split(',');
    const byteString = atob(base64);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const uintArray = new Uint8Array(arrayBuffer);

    for (let i = 0; i < byteString.length; i++) {
      uintArray[i] = byteString.charCodeAt(i);
    }

    const mimeString = metadata.split(':')[1].split(';')[0];
    return new Blob([uintArray as BlobPart], { type: mimeString });
  }
}
